import { Location } from "history";
import { inject, observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { Prompt, useHistory } from "react-router-dom";
import RequestStore from "../stores/requestStore";

interface InjectedProps {
    requestStore?: RequestStore;
}

interface Props extends InjectedProps {
    onSave: () => Promise<any>;
    isNotSaved: () => boolean;
    disableBlocking?: boolean
}

const UnsavedChangesDialog = ({ onSave, isNotSaved, requestStore }: Props) => {
    const [blockedLocation, setBlockedLocation] = useState<Location>();
    const [shouldNavigate, setShouldNavigate] = useState(false);
    const [isBlocking, setBlocking] = useState(true);
    const history = useHistory();


    useEffect(() => {
        if (shouldNavigate && blockedLocation) {
            history.push(blockedLocation);
            setShouldNavigate(false);
            setBlockedLocation(undefined);
        }
    }, [shouldNavigate, blockedLocation, history]);

    useEffect(() => {
        if (!blockedLocation || shouldNavigate) {
            return;
        }

        requestStore?.showDirtyDialog({
            text: 'You have unsaved changes in the flow step',
            onDismiss: () => setBlockedLocation(undefined),
            onSave: async () => {
                await onSave();
                setBlocking(false);
                setShouldNavigate(true);
            },
            onForget: () => {
                setBlocking(false);
                setShouldNavigate(true);
            }
        })
    }, [blockedLocation, shouldNavigate, onSave]);

    return (<>
      {isNotSaved() && (
        <Prompt
          when={isBlocking}
          message={(location) => {
              if (!blockedLocation) {
                  setBlockedLocation(location);
                  return false;
              }
              return true;
          }} />
      )}
    </>)
}

export default inject("requestStore")(observer(UnsavedChangesDialog));
